<script lang="ts">
	import InputWarning from '$lib/components/form/inputWarning/InputWarning.svelte'
	import { _ } from '@repo/i18n'
	import { slugify } from '@repo/ui'
	import { Input } from '@repo/ui'
	import { run } from 'svelte/legacy'

	interface Props {
		publicId: string
		name: string
		withUser?: boolean
	}

	let { publicId = $bindable(), name, withUser = false }: Props = $props()

	let slugAutocomplete = $state(true)

	run(() => {
		if (slugAutocomplete && name) {
			publicId = slugify(name)
		}
	})
</script>

<Input
	name="publicId"
	help={withUser ? null : $_('form.publicIdHelp')}
	hideRequired
	label={$_('form.publicId')}
	max={50}
	min={2}
	oninput={() => {
		slugAutocomplete = false
		publicId = slugify(publicId)
	}}
	placeholder={$_('form.publicIdPlaceholder')}
	required
	bind:value={publicId}
>
	<InputWarning text={$_('signUp.tenant.beCareful')} />
</Input>
